import React from 'react';

import {parseBbCodes} from './parse-bb-codes';
import {parseTree} from './parse-tree';
import {treeToNodes} from './tree-to-nodes';
import {parseInlineTags} from './parse-inline-tags';
import {tipograph} from './tipograph';

type Props = {
	text: string;
	payload?: Record<string, any>;
};

export type ParseResult = {
	tag: string;
	content?: string;
	tmp?: any;
	children?: ParseResult[];
	parent?: ParseResult;
	props?: any;
};

export function getMarkdownTree(content: string): ParseResult[] {
	const bbCodesTree = parseBbCodes(content);
	return parseInlineTags(parseTree(bbCodesTree));
}

export const Markdown: React.FC<Props> = ({text, payload}) => {
	if (!text) return null;
	const tree = getMarkdownTree(text).map(tipograph);
	return <>{treeToNodes(tree, payload || {})}</>;
};

/**
 * Разметка внутри строки: одиночный абзац разворачивается в TextNode,
 * чтобы результат можно было вкладывать в <em>/<span> — <p> там невалиден.
 * Многострочный текст рендерится как обычный Markdown.
 */
export const MarkdownInline: React.FC<Props> = ({text, payload}) => {
	if (!text) return null;
	const tree = getMarkdownTree(text).map(tipograph);
	const nodes = tree.length === 1 && tree[0].tag === 'p' ? [{...tree[0], tag: 'TextNode'}] : tree;
	return <>{treeToNodes(nodes, payload || {})}</>;
};
